<div (click)="open('/main/paddocks')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    @if (paddockStore.loading()) {
        <lib-loading-placeholder [show]="true"/>
    } @else {
        <div class=" d-flex justify-content-between">
            <div class=" fs-main fw-bold mb-3">Paddocks</div>
            <div class=" mt-auto mb-auto">
                <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
            </div>
        </div>
        <app-paddock-svg
            [colored]="true"
            [height]="'30px'"
            [width]="'30px'"/>
        <span class="p-2">{{ paddockStore.entities().length }}</span>
    }
</div>
